import type { ChartType } from '@shared/schemas/chart';

export interface ChartColorMode {
  usesSingleColor: boolean; // Can the chart conceptually start from/be represented by a single primary color?
  requiresPalette: boolean; // Does the chart ultimately need an array of colors to render distinct segments/series?
}

const chartColorBehavior: Record<ChartType, ChartColorMode> = {
  bar: { usesSingleColor: true, requiresPalette: false },
  line: { usesSingleColor: true, requiresPalette: false },
  pie: { usesSingleColor: true, requiresPalette: true },      // Can use singleColor to generate shades, or a full palette
  doughnut: { usesSingleColor: true, requiresPalette: true },// Can use singleColor to generate shades, or a full palette
  area: { usesSingleColor: true, requiresPalette: false }, 
  scatter: { usesSingleColor: true, requiresPalette: false },
  // Removed other non-standard types like radar, polarArea etc.
};

export const getChartColorMode = (chartType?: ChartType): ChartColorMode => {
  if (chartType && chartColorBehavior[chartType]) {
    return chartColorBehavior[chartType];
  }
  // Default behavior: suitable for bar/line charts
  return { usesSingleColor: true, requiresPalette: false }; 
};

// Example usage:
// const mode = getChartColorMode('pie');
// if (mode.requiresPalette) { ... } 